import { useQuery } from '@tanstack/react-query'
import { getUserAlertSettings } from '../../../../apis/userDetailedSettings'
import { queryKeys } from '../../../../shared'

/**
 * Alert設定 Query hook
 */
export const useAlertSettingsQuery = () => {
  return useQuery({
    queryKey: queryKeys.ocrSettings.alert(),
    queryFn: getUserAlertSettings,
  })
}
